import React from 'react';
import { Link } from 'react-router-dom';
import {
  SiteShell, PageHead, H1, P, INK, SUB, LINE, CARD, BG2,
} from '../site/shell';

const sec = { padding:'clamp(40px,6vw,72px) clamp(20px,5vw,48px)' };

/* ══════════════════════════════════════════════════════════════════
   CHANGELOG — the trust page. Add an entry every time you ship a
   version. Most recent first.
   type: 'new' | 'improved' | 'fixed'  ·  product: short label
   ══════════════════════════════════════════════════════════════════ */
const TYPE_C = { new:'#22C55E', improved:P, fixed:'#E0A82E' };
const TYPE_L = { new:'New', improved:'Improved', fixed:'Fixed' };

const CHANGELOG = [
  { date:'2026-09-09', product:'Site', version:null,
    changes:[
      ['new','New positioning: multiplayer and server tools you configure without code.'],
      ['new','Product pages, Services with a brief, Studio and this public Changelog.'],
      ['improved','Dark theme built for people who spend the day in IDEs and server panels.'],
    ] },
];

function fmt(d) {
  const [y,m,day] = d.split('-');
  const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  return `${day} ${months[+m-1]} ${y}`;
}

export function ChangelogPage() {
  return (
    <SiteShell active="" title="Changelog" desc="The public log of every version of our products, by date. See how each tool evolves before you buy.">
      <PageHead tag="Changelog" title="Everything that" accent="changes."
        lead="The public log of every version, product by product, by date. Before you buy a tool, you see exactly how it evolves." />

      <section style={{ ...sec, paddingTop:0 }}>
        <div style={{ maxWidth:820, margin:'0 auto' }}>
          {CHANGELOG.map((e,i) => (
            <div key={i} className="reveal two-col" style={{ display:'grid', gridTemplateColumns:'160px 1fr', gap:24, paddingBottom:32, marginBottom:32, borderBottom:`1px solid ${LINE}` }}>
              <div>
                <p style={{ fontSize:14,fontWeight:700,color:INK }}>{fmt(e.date)}</p>
                <span style={{ display:'inline-block',marginTop:8,fontSize:11,fontWeight:700,color:P,background:'rgba(163,102,255,.12)',border:`1px solid ${LINE}`,padding:'4px 10px',borderRadius:999 }}>{e.product}{e.version?` · ${e.version}`:''}</span>
              </div>
              <div style={{ background:CARD,border:`1px solid ${LINE}`,borderRadius:16,padding:'20px 22px',display:'flex',flexDirection:'column',gap:12 }}>
                {e.changes.map(([t,txt],j) => (
                  <div key={j} style={{ display:'flex',gap:12,alignItems:'flex-start' }}>
                    <span style={{ flexShrink:0,fontSize:10.5,fontWeight:700,letterSpacing:'.04em',textTransform:'uppercase',color:TYPE_C[t],background:`${TYPE_C[t]}1c`,padding:'4px 9px',borderRadius:6,marginTop:1,minWidth:74,textAlign:'center' }}>{TYPE_L[t]}</span>
                    <span style={{ fontSize:15,color:INK,lineHeight:1.6,fontWeight:500 }}>{txt}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}

          <div className="reveal" style={{ background:BG2,border:`1px dashed ${LINE}`,borderRadius:18,padding:'32px 26px',textAlign:'center' }}>
            <p style={{ ...H1,fontSize:18,color:INK,marginBottom:8 }}>Product versions show up here.</p>
            <p style={{ fontSize:15,color:SUB,fontWeight:500,maxWidth:440,margin:'0 auto 18px',lineHeight:1.6 }}>As each tool launches, every update is logged on this page, by date.</p>
            <Link to="/produtos" className="btn-g" style={{ height:44 }}>View products →</Link>
          </div>
        </div>
      </section>
    </SiteShell>
  );
}
